module.exports = __webpack_public_path__ + "static/media/SDTM10-611.a816ffd5.jpg";